import React from 'react';

import { getUnitConversion, getFormattedWeightNumber } from '../vignette.utils';

const customTooltip = ({ info, total, acvComponent, refUnit }) => {
  const percentage = ((info.value / total) * 100).toFixed(2);

  return (
    <div
      style={{
        background: 'white',
        padding: '8px',
        border: '1px solid #A7AFB2',
        borderRadius: '4px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          zIndex: 100,
        }}
      >
        <span
          style={{
            display: 'block',
            width: '12px',
            height: '12px',
            background: `${info.color}`,
            marginRight: '7px',
          }}
        ></span>
        <span>
          {info.id} :
          <strong style={{ marginLeft: '6px' }}>
            {getFormattedWeightNumber(info.value)} {getUnitConversion(info.value)}
            {!acvComponent && refUnit === 'm²' ? '/m²' : ''}{' '}
          </strong>{' '}
          | <strong>{percentage}%</strong>
        </span>
      </div>
    </div>
  );
};

export default customTooltip;
